import Head from "next/head";
import { useRouter } from "next/router";
import { processLensColorForDisplay, useGlassesStore } from "zus/glassesStore";
import * as ga from 'lib/ga';
import { slugToString } from "functions/slug";
import { generateGlassesImage } from "utils/image.utils";
import { useEffect } from "react";
import { GoogleReviewData, GoogleReviewModel } from "constants/dataTypes";


export default function FrameProductHeaderComponent({ price, reviews }: { price: number, reviews?: GoogleReviewModel }) {
    const router = useRouter();
    const prodTitle = useGlassesStore((state) => state.category_display);
    const frameColorDisplayZ = useGlassesStore((state) => state.frame_color_display);

    const frameColorZ = useGlassesStore((state) => state.frame_color);
    const armsColorZ = useGlassesStore((state) => state.arms_color);


    const pageLocale = router.locale?.replace('international', '');
    const pageFullUrl = `${process.env.NEXT_PUBLIC_SITE_URL}` +
        `${pageLocale == '' ? '' : pageLocale + '/'}` +
        `${router.asPath}`.replace(/^\/+/g, '');

    const productFullnameWcategory = frameColorDisplayZ + ' Glasses Frame Set & Eyeglasses Frame';

    useEffect(() => {

        ga.addDataLayer({
            event: 'ImpCompleted',
            ecommerce: {
                detail: {
                    actionField: { list: 'Shop' },
                    products: [
                        {
                            name: productFullnameWcategory,
                            price: price,
                            category: prodTitle,
                            variant: slugToString(frameColorZ)
                        }
                    ]
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath]);




    const getSeoImage = () => {

        const lensColorSel = processLensColorForDisplay('clear');
        return generateGlassesImage(frameColorZ, armsColorZ, "0", lensColorSel);

    };


    return (<Head>
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content="Dresden" />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="400" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label2" content="Availability" />
        <meta name="twitter:data2" content="In stock" />
        <meta property="og:availability" content="instock" />
        <meta property="product:availability" content="instock" />
        <meta property="product:condition" content="new" />


        <meta name="twitter:title" content={`${productFullnameWcategory}`} />
        <meta name="og:title" content={`${productFullnameWcategory}`} />
        <meta property="og:image" content={`${getSeoImage()}`} />
        <meta property="twitter:image" content={`${getSeoImage()}`} />

        <title>{`${productFullnameWcategory} | Dresden Vision`}</title>
        <meta
            name="description"
            content={`${`${productFullnameWcategory}`} are on this page with advantageous price and Dresden Vision assurance. Shop ${`${productFullnameWcategory}`} online.`}
        />
        <meta
            property="og:description"
            content={`${`${productFullnameWcategory}`} are on this page with advantageous price and Dresden Vision assurance. Shop ${`${productFullnameWcategory}`} online.`}
        />
        <meta
            name="twitter:description"
            content={`${`${productFullnameWcategory}`} are on this page with advantageous price and Dresden Vision assurance. Shop ${`${productFullnameWcategory}`} online.`}
        />
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'https://schema.org/',
                    '@type': 'Product',
                    name: `${productFullnameWcategory}`,
                    image: [getSeoImage()],
                    description: `${`${productFullnameWcategory}`} are on this page with advantageous price and Dresden Vision assurance. Shop ${`${productFullnameWcategory}`} online.`,
                    brand: {
                        '@type': 'Brand',
                        name: 'DRESDEN VISION'
                    },
                    ...(reviews && {
                        "aggregateRating": {
                            "@type": "AggregateRating",
                            "ratingValue": reviews.rating.toFixed(2),
                            "reviewCount": reviews.review_count
                        },
                        "review": reviews.data.map((review: GoogleReviewData) => ({
                            "@type": "Review",
                            "author": {
                                "@type": "Person",
                                "name": review.reviewer_displayName
                            },
                            "reviewRating": {
                                "@type": "Rating",
                                "ratingValue": review.starRating,
                                "bestRating": 5
                            },
                            "reviewBody": review.review
                        }))
                    }),
                    offers: {
                        '@type': 'Offer',
                        url:
                            `${pageFullUrl}`,
                        priceCurrency:
                            router.locale === 'nz'
                                ? 'NZD'
                                : router.locale === 'ca'
                                    ? 'CAD'
                                    : 'AUD',
                        price: price,
                        itemCondition: 'https://schema.org/UsedCondition',
                        availability: 'https://schema.org/InStock'
                    }
                })
            }}
        /></Head>);
}
